import { lighten, darken, rgba, tint } from 'polished'

export const black = '#000'
export const white = '#fff'

// Site Specific Colors
export const yellow = '#f9b60d'
export const red = '#EF4F4F'
export const green = '#77B305'
export const blue = '#00adeb'
export const navy = '#031a45'
export const orange = '#e68f23'

export const mediumBlue = '#004c9a'
export const lightBlue = '#defaff'
export const blue2 = '#91d4f4'
export const pink = '#ea50c5'
export const brown = '#4c291b'
export const gold = yellow

// Basic Colors
export const transparent = 'transparent'
export const currentcolor = 'currentcolor'
export const bgColor = white
export const mainColor = blue
export const alert = red
export const notify = yellow
export const success = green
export const textColor = navy
export const lightTextColor = tint(0.3, textColor)
export const lightGrey = '#f7f8f9'
export const hrColor = rgba(textColor, 0.15)

// Color Variations
export const mainColorDarken = darken(0.07, mainColor)
export const mainColorLighten = lighten(0.07, mainColor)
